import { logger } from '@/lib';
import type { AddonApp, AddonAppResponse } from '../types';
import { toAddonApps } from '../utils/addonAppMapping';

// Fallback until GET /api/v1/addon-apps exists in the backend
const MOCK_ADDON_APPS: AddonAppResponse[] = [{ name: 'DIMA', url: '/dima' }];

// Loads the addon apps the current user can open; invalid entries are dropped during mapping
export async function fetchAddonApps(): Promise<AddonApp[]> {
  try {
    const responses = await loadAddonAppResponses();
    return toAddonApps(responses);
  } catch (error) {
    logger.error('Failed to load addon apps', { error });
    throw error;
  }
}

// TODO(addon-apps): Switch to the real endpoint once the backend ships it:
//   import { api } from '@/api';
//   return api.get<AddonAppResponse[]>('/v1/addon-apps');
async function loadAddonAppResponses(): Promise<AddonAppResponse[]> {
  return MOCK_ADDON_APPS;
}
